import { doctorBffApi } from '../doctorBffApi.slice';
import {
  Automation,
  AutomationActionExecutionLog
} from '../automation/automation.model';
import { ID } from '@ianesthesie-kit/services';
import { AutomationService } from './automation.service';
import { WithPatientId } from '../surgicalEvent';
import { isEmpty } from '@/util';

export const automationApi = doctorBffApi.injectEndpoints({
  overrideExisting: false,
  endpoints: (builder) => ({
    hospitalAutomations: builder.query<Record<ID, Automation>, void>({
      providesTags: ['HospitalSpecificData'],
      queryFn: () =>
        AutomationService.fetchHospitalAutomations().then((data) => ({ data }))
    }),

    latestAutomationExecutions: builder.query<
      AutomationActionExecutionLog[],
      WithPatientId<{ minutesAgo?: number }>
    >({
      queryFn: ({ patientId, minutesAgo = 10 }) =>
        AutomationService.getInstance(patientId)
          .fetchAutomationExecutionsForLastMinutes(minutesAgo)
          .then((r) => ({
            data: r.data
          }))
          .catch((error) => ({ error })),
      providesTags: ['AutomationActionExecutionLogs', 'HospitalSpecificData']
    })
  })
});

export const { useHospitalAutomationsQuery: useHospitalAutomations } =
  automationApi;

const { useLatestAutomationExecutionsQuery: useLatestExecutions } =
  automationApi;
type ParamType = Parameters<typeof useLatestExecutions>[0];

export const useLatestAutomationExecutions = (arg: ParamType) => {
  const { data: hospitalAutomations } = useHospitalAutomations();
  return useLatestExecutions(arg, {
    skip: !(arg as any)?.patientId || isEmpty(hospitalAutomations),
    selectFromResult: (res) => ({
      ...res,
      data: res.data?.map((action) => ({
        ...action,
        automation: hospitalAutomations?.[action.automationId]
      }))
    })
  });
};
